import {uuidRegex} from '@/config/constants';

export const ROUTES = {
  HOME: '/',
  PUBLIC_CREATOR_PROFILE: '/p',
  CAMPAIGNS: '/campaigns',
  THREADS: '/collaborations',
  CONTENT__LIBRARY: '/content-library',
  PARTNERSHIPS: '/partnerships',
  PARTNERSHIPS_CREATE: `/partnerships/create/${uuidRegex}`, // /partnerships/create/:partnershipId
  STATS: '/stats',
  NOT_FOUND: '/not-found',
  MAINTENANCE: '/maintenance',
  ERROR: '/errors/(deactivated|session-expired|forbidden)',
  PUBLIC_PROFILE: `/p/${uuidRegex}`, // /p/:profileId
  PROFILE_SHARED_LIST: `/shared-list(/${uuidRegex})?`, // /shared-list/:profileId?type=(proposals|contracts|creator_groups|labels)&ref_id=(:campaignId|:userGroupId|:labelId)&filter=(is_pending|is_shortlisted|all)
  VIDEO_PREVIEWS_URL: `/video_previews/${uuidRegex}`, // /video_previews/:contentSubmissionId
  VIDEO_PREVIEWS: `/video_previews`, // /video_previews/:contentSubmissionId
  PHOTO_PREVIEWS_URL: `/photo_previews/${uuidRegex}`, // /photo_previews/:contentSubmissionId
  PHOTO_PREVIEWS: `/photo_previews`, // /photo_previews/:contentSubmissionId
  SIGN_UP: '/signup',
  SIGN_UP_REACT_OLD: '/sign-up',
  SIGN_UP_CONTENT_LAB: '/content-lab/signup',
  LOGIN: '/login',
  LOGIN_CONTENT_LAB: '/content-lab/login',
  AUTH_ERROR: '/auth-error',
  UPGRADE_SUBSCRIPTION: '/upgrade',
  AI_STUDIO: '/ai-studio',
  AI_STUDIO_DASHBOARD: '/ai-studio/generated-content/dashboard',
  MOBILE_NOT_SUPPORTED: '/mobile-not-supported',
  PRICING: '/pricing',
  NEW_CAMPAIGNS: '/new-campaigns',
  NEW_CAMPAIGN_BRIEF: `/new-campaigns/${uuidRegex}/brief/edit`, // /new-campaigns/:campaignId/brief/edit
  SEARCH: '/search',
  CREATOR_CRM: '/creator-crm',
  RECRUIT_CRM: '/recruit-crm',
  CAMPAIGNS_V2: '/campaigns-v2',
  MY_CREATORS: '/creators',
  CREATOR_PROFILE: '/creator-profile',
  CONTENT_LIBRARY: '/content-library-react',
  SHARED_LIST: '/shared-list',
  PREFERENCES: '/preferences',
  ORGANIZATION_SETTINGS: '/organization-settings',
  PREFERENCES_TERMS_OF_SERVICE: '/preferences/terms-of-service',
  ORGANIZATION_SETTINGS_BRANDS: '/organization-settings/brands',
  ORGANIZATION_SETTINGS_USERS: '/organization-settings/users',
  ORGANIZATION_SETTINGS_PLAN_BILLING: '/organization-settings/plan-billing',
  ORGANIZATION_SETTINGS_PURCHASE_HISTORY:
    '/organization-settings/purchase-history',
  CAMPAIGN_BRIEF: `/campaigns/${uuidRegex}/brief`,
  CAMPAIGN_RECRUIT: `/campaigns/${uuidRegex}/recruit`,
  CAMPAIGN_SUGGESTED: `/campaigns/${uuidRegex}/candidates`,
  CAMPAIGN_INVITED: `/campaigns/${uuidRegex}/candidates/invited`,
  CAMPAIGN_APPLICATIONS: `/campaigns/${uuidRegex}/proposals`,
  CAMPAIGN_PARTICIPANTS: `/campaigns/${uuidRegex}/contracts`,
  CAMPAIGN_ASSETS: `/campaigns/${uuidRegex}/content-downloads`,
  CAMPAIGN_STATS: `/campaigns/${uuidRegex}/stats`,
  CAMPAIGN_STATS_ORGANIC: '/campaigns/:id/stats/organic',
  CAMPAIGN_SETTINGS: `/campaigns/${uuidRegex}/settings`,
  CAMPAIGN_TIMELINE: `/campaigns/${uuidRegex}/timeline`,
  CAMPAIGN: `/campaigns/${uuidRegex}/*`,
  CONTENT_LAB: '/content-lab',
  CONTENT_LAB_FEATURE: '/content-lab/feature',
  CONTENT_LAB_TRANSLATE: '/content-lab/feature/dub',
  CONTENT_LAB_REPHRASE: '/content-lab/feature/rephrase',
  CONTENT_LAB_REFORMAT: '/content-lab/feature/reformat',
  CONTENT_LAB_FEATURE_ASSETS: '/content-lab/feature/assets',
  CONTENT_LAB_TRANSLATE_ASSETS: '/content-lab/feature/dub/assets',
  CONTENT_LAB_REPHRASE_ASSETS: '/content-lab/feature/rephrase/assets',
  CONTENT_LAB_REFORMAT_ASSETS: '/content-lab/feature/reformat/assets',
  CONTENT_LAB_UPSCALE: '/content-lab/feature/upscale',
  CONTENT_LAB_UPSCALE_ASSETS: '/content-lab/feature/upscale/assets',
  CONTENT_LAB_ONBOARDING: '/content-lab/onboarding',
  CONTENT_LAB_ASSETS: '/content-lab/assets',
  CONTENT_LAB_PRICING: '/content-lab/pricing',
  VETTING: '/vetting',
  VETTING_HUB: '/vetting/hub',
  CREATOR_VETTING_REPORT: `/vetting/creators/${uuidRegex}/report/${uuidRegex}`,
  CREATOR_VETTING_REPORT_DEV: `/vetting/creators/\\d+/report/${uuidRegex}`, // TODO: remove once we remove the mock data of the vetting report
  OFF_PLATFORM_REVIEW: '/off-platform-review',
  CAMPAIGNS_V2_BRIEF: '/campaigns-v2/[^/]+/brief',
  CAMPAIGNS_V2_DETAIL: '/campaigns-v2/[^/]+/.+',
};
export const UNAUTHENTICATED_ROUTES = [
  ROUTES.ERROR,
  ROUTES.AUTH_ERROR,
  ROUTES.PUBLIC_PROFILE,
  ROUTES.PROFILE_SHARED_LIST,
  ROUTES.VIDEO_PREVIEWS_URL,
  ROUTES.PHOTO_PREVIEWS_URL,
  ROUTES.SIGN_UP,
  ROUTES.SIGN_UP_REACT_OLD,
  ROUTES.LOGIN,
  ROUTES.OFF_PLATFORM_REVIEW,
];
export const HIDE_BRAND_HEADER_ROUTES = [
  ...UNAUTHENTICATED_ROUTES,
  ROUTES.UPGRADE_SUBSCRIPTION,
  ROUTES.PRICING,
  ROUTES.CONTENT_LAB_PRICING,
  ROUTES.CONTENT_LAB_ONBOARDING,
];

export const HIDE_MENU_ROUTES = [
  ...HIDE_BRAND_HEADER_ROUTES,
  ROUTES.AI_STUDIO_DASHBOARD,
  ROUTES.PRICING,
  ROUTES.CREATOR_VETTING_REPORT,
  ROUTES.CREATOR_VETTING_REPORT_DEV, // TODO: remove once we remove the mock data of the vetting report
  ROUTES.CONTENT_LAB_FEATURE,
  ROUTES.CONTENT_LAB_ONBOARDING,
  ROUTES.CONTENT_LAB_FEATURE_ASSETS,
  ROUTES.PARTNERSHIPS_CREATE,
  ROUTES.CAMPAIGNS_V2_DETAIL,
];

export const HIDE_SUBSCRIPTION_BANNER_ROUTES = [
  ...HIDE_BRAND_HEADER_ROUTES,
  ROUTES.AI_STUDIO_DASHBOARD,
  ROUTES.CONTENT_LAB,
];

export const CONTENT_LAB_FLOW_ROUTES = {
  [ROUTES.CONTENT_LAB_TRANSLATE]: 'translate',
  [ROUTES.CONTENT_LAB_TRANSLATE_ASSETS]: 'translate',
  [ROUTES.CONTENT_LAB_REPHRASE]: 'rephrase',
  [ROUTES.CONTENT_LAB_REPHRASE_ASSETS]: 'rephrase',
  [ROUTES.CONTENT_LAB_REFORMAT]: 'reformat',
  [ROUTES.CONTENT_LAB_REFORMAT_ASSETS]: 'reformat',
  [ROUTES.CONTENT_LAB_ONBOARDING]: 'onboarding',
  [ROUTES.CONTENT_LAB_ASSETS]: 'library',
  [ROUTES.CONTENT_LAB_FEATURE_ASSETS]: 'library',
  [ROUTES.CONTENT_LAB_PRICING]: 'pricing',
};

export const CONTENT_LAB_ROUTES = {
  [ROUTES.CONTENT_LAB]: 'homepage',
  ...CONTENT_LAB_FLOW_ROUTES,
  [ROUTES.CONTENT_LAB_FEATURE]: 'feature',
};

export const BACK_BUTTON_ROUTES = [
  ...Object.keys(CONTENT_LAB_FLOW_ROUTES),
  ROUTES.CONTENT_LAB_FEATURE,
];

export const MESSAGE_CREATOR_ID_QUERY_PARAM = 'messageCreatorId';
export const PREVIEW_CREATOR_ID_QUERY_PARAM = 'previewCreatorId';

export const ACTIVITY_FEED_QUERY_PARAM = 'activityFeed';
export const ACTIVITY_FEED_CREATOR_VALUE = 'creator';
